import Vue from 'vue'
import Router from 'vue-router'
// 路由的懒加载效果
const home = () => import('../views/index.vue')
// const Detail = () => import('../pages/detail.vue')

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/home' },  ///重定向到登录页
    {
      path: '/home',
      name: 'home',
      component: home,
    },
    // {
    //   path: '/detail',
    //   name: 'detail',
    //   component: Detail,
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js